import React, { useState, useEffect } from "react";
import { stateWiseCountApi } from "../../../Marketing/maketingComponents/actioncreator";
import ReactApexChart from "react-apexcharts";
import Skeleton from "react-loading-skeleton";

const AgestatusData = ({ admin, payload, applyFilter, clearApplyFilter }) => {
    const [nameOpportunity, setNameopportunity] = useState([])
    const [dataOpportunity, setDataopportunity] = useState([])

  
    const [rejectReasonData, setRejectReasonData] = useState([]);
    const [graphData, setGraphData] = useState([]);
    const [optionsData, setOptionsData] = useState('');
   

    useEffect(() => {
        getdataapi();
    }, []);

    useEffect(() => {
        if(applyFilter == true){
            getdataapi();
        }
    }, [applyFilter]);

    const getdataapi = () => {
        stateWiseCountApi(
            payload,
            (callBack) => {

                setRejectReasonData(callBack);
                makegraphDataOpportunity(callBack)
                clearApplyFilter()

            },
            (error) => {
                console.log(error);
            }
        );
    };

    

    const prepareChartData = (data) => {

        const categories = Object.values(data.xaxis.categories);
        const seriesData = Object.values(data.xaxis.categories);
        const options = {
            series: [{
                data: seriesData
            }],
            chart: {
                type: 'bar',
                height: 350
            },
            plotOptions: {
                bar: {
                    borderRadius: 4,
                    horizontal: true,
                }
            },
            dataLabels: {
                enabled: false
            },
            xaxis: {
                categories: categories
            }
        };
        setOptionsData(options);
        console.log(options)
    };


    const makegraphDataOpportunity = (To) => {
        let name = [];
        let data = [];

        for (const item of To) {
            const { count, state, } = item;

            name.push(state);

            data.push(count);
        }

        setNameopportunity(name);
        setDataopportunity(data);

        console.log(Object.values(nameOpportunity))

    }
    var options = {
        series: [{
            data: Object.values(dataOpportunity),

        }],
        chart: {
            type: 'bar',
            height: 350
        },
        plotOptions: {
            bar: {
                horizontal: true,
                barHeight: '50%',
                barWidth: '90%',
                borderRadius: '0 10 30 90'

            }
        },
        colors: ['#7978E9'],
        dataLabels: {
            enabled: false
        },
        xaxis: {
            categories: nameOpportunity,
        },


    };

    return (
        <div>
            <div className="" style={{ marginTop:window.innerWidth > 1800 ? "60px" :'30px',marginBottom: '20px', borderRadius: '10px', minHeight: '600px',boxShadow:'0px 2px 6px 4px rgba(50, 71, 92, 0.02), 0px 2px 9px 0px rgba(50, 71, 92, 0.04), 3px 4px 4px 0px rgba(0, 0, 0, 0.25)' }}>
                <div className="bg-white p-4 " style={{ padding: '15px' }}>
                    <h5 style={{ color: '#1d3557', fontWeight: '700' }}> <strong style={{ paddingTop: '10px' }}>Form Status Stats</strong></h5>
                   
                    <div className="row">
                        <div className="col-sm-6 col-xs-12 other-table">
                            <div className='credit-table' style={{ fontSize: '12px'}} >
                                <table>
                                    <thead style={{  borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
                                        <tr className="thead-class">
                                            <th style={{ width: '20%', }} className="">
                                                <b>State</b>
                                            </th>
                                            <th style={{ width: '20%', }} className="">
                                                <b>Month</b>
                                            </th>
                                            <th style={{ width: '20%' }} className="">
                                                <b>Counts</b>
                                            </th>
                                            <th style={{ width: '20%' }} className="">
                                                <b>Percentage</b>
                                            </th>

                                        </tr>
                                    </thead>
                                    {rejectReasonData.length > 0 ?
                                        <tbody style={{ height: '650px', borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }}>
                                            {rejectReasonData.map((data1, i) => {

                                                return (
                                                    <tr style={{ borderBottom: "none", fontWeight: '400' }} key={i}>
                                                        <td style={{ width: '20%' }} scope="col">
                                                            {data1.state}
                                                        </td>
                                                        <td style={{ width: '20%' }} scope="col">
                                                            {data1.month}
                                                        </td>
                                                        <td style={{ width: '20%' }} scope="col">
                                                            {data1.count}
                                                        </td>
                                                        <td style={{ width: '20%' }} scope="col">
                                                            {data1.percentage}
                                                        </td>

                                                    </tr>
                                                )

                                            })}
                                            <tr className="thead-class" style={{ fontWeight: 'bold', background: '#B9D8F973' }}>
                                                <td style={{ borderBottomLeftRadius: '10px', width: '40%' }}><b>Total</b></td>
                                                <td style={{ width: '40%' }}>
                                                    <b>{rejectReasonData[0].total}</b>
                                                </td>
                                                <td ></td>
                                                <td style={{ borderBottomRightRadius: '10px' }}></td>
                                            </tr>

                                        </tbody>
                                        :
                                        <tbody style={{ height: '650px', borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }}>
                                            <tr>
                                                <td><Skeleton height={40} /></td>
                                                <td><Skeleton height={40} /></td>
                                                <td><Skeleton height={40} /></td>

                                            </tr>

                                            <tr>
                                                <td><Skeleton height={40} /></td>
                                                <td><Skeleton height={40} /></td>
                                                <td><Skeleton height={40} /></td>

                                            </tr>
                                            <tr>
                                                <td><Skeleton height={40} /></td>
                                                <td><Skeleton height={40} /></td>
                                                <td><Skeleton height={40} /></td>
                                            </tr>
                                            <tr>
                                                <td><Skeleton height={40} /></td>
                                                <td><Skeleton height={40} /></td>
                                                <td><Skeleton height={40} /></td>
                                            </tr>
                                            <tr>
                                                <td><Skeleton height={40} /></td>
                                                <td><Skeleton height={40} /></td>
                                                <td><Skeleton height={40} /></td>
                                            </tr>
                                            <tr>
                                                <td><Skeleton height={40} /></td>
                                                <td><Skeleton height={40} /></td>
                                                <td><Skeleton height={40} /></td>
                                            </tr>
                                            <tr>
                                                <td><Skeleton height={40} /></td>
                                                <td><Skeleton height={40} /></td>
                                                <td><Skeleton height={40} /></td>
                                            </tr>
                                        </tbody>
                                    }
                                </table>
                            </div>
                        </div>
                        <div className="col-sm-6 col-xs-12 " id='chart'>
                            <div style={{ border: '1px solid rgba(0, 0, 0, 0.15)', padding: '10px', borderRadius: '10px', marginTop: '21px' }}>
                                <h5><b>Form Status Stats</b></h5>
                                <ReactApexChart options={options} series={options.series} type="bar" height={630} width={'100%'} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AgestatusData;
